import { throttle } from 'lodash-es';
import Cookies from 'js-cookie';

export const Helpers = (function () {
	'use strict';

	function init() {
		cookie_banner();
		responsive_videos();
		body_scroll();
		accordions();
		animationObservers();
		slideInTextLinks();
		createArrowButtons();
		taxonomyDropdown();
	}

	function isElementInViewport(el) {
		var rect = el.getBoundingClientRect();

		return rect.top <= window.innerHeight;
	}

	function taxonomyDropdown() {
		const dropdownEl = document.getElementById('default-taxonomy-dropdown');

		if (!dropdownEl) return;

		dropdownEl.addEventListener('change', (ev) => (window.location = dropdownEl.value));
	}

	function createArrowButtons() {
		const arrowHTML =
			'<svg width="18px" height="12px" viewBox="0 0 18 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><line x1="0" y1="5" x2="16" y2="5" stroke-width="2" fill="none" stroke="currentColor"></line><polyline points="10 0 16 5 10 10" stroke-width="2" fill="none" stroke="currentColor"></polyline></svg>';

		document
			.querySelectorAll('.btn-arrow')
			.forEach(
				(btnArrow) =>
					(btnArrow.innerHTML = btnArrow.classList.contains('.btn-arrow--reverse')
						? arrowHTML + btnArrow.innerHTML
						: btnArrow.innerHTML + arrowHTML)
			);
	}

	function animationObservers() {
		document.querySelectorAll('.pxblock').forEach((pxblock) => {
			if (isElementInViewport(pxblock) && pxblock.querySelector('.container') ) pxblock.querySelector('.container').classList.add('animated');
		});

		const observerCallback = (entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && entry.target.querySelector('.container'))
					entry.target.querySelector('.container').classList.add('animated');

				if (entry.target.classList.contains('pxblock--hero') && entry.target.nextElementSibling.querySelector('.container')) {
					entry.target.nextElementSibling.querySelector('.container').classList.add('animated');
				}
			});
		};

		const io = new IntersectionObserver(observerCallback, { threshold: 0, rootMargin: '0px 0px -250px 0px' });
		const observables = document.querySelectorAll('.pxblock');

		observables.forEach((el) => io.observe(el));

		document.querySelectorAll('.article,.news').forEach((article) => article.classList.add('animated'));
	}

	function slideInTextLinks() {
		const arrowLinks = document.querySelectorAll('.btn-arrow');

		arrowLinks.forEach((arrowLink) => {
			const textContent = arrowLink.innerText;

			arrowLink.setAttribute('data-text', textContent);
		});
	}

	function externalLinksProcessing() {
		if (typeof wp !== 'undefined') return;

		const regex = new RegExp(/https?:\/\/([a-z0-9]+[.])*amsoil[.]com/g);

		document.querySelectorAll('a').forEach((link) => {
			const linkIsInternal = regex.test(link.href);

			if (!linkIsInternal) link.setAttribute('target', '_blank');
		});
	}

	function cookie_banner() {
		let banner = document.querySelector('.cookie-banner');

		if (!banner) return;

		banner.querySelectorAll('button').forEach((btn) => {
			btn.addEventListener('click', (ev) => {
				ev.preventDefault();

				let acceptance = btn.classList.contains('accept') ? 'yes' : 'no';

				Cookies.set('acceptedCookiePrompt', acceptance);
				window.location.reload();
			});
		});
	}

	function responsive_videos() {
		let responsiveVideos = document.querySelectorAll('.responsive-video');

		if (!responsiveVideos) return;

		responsiveVideos.forEach((vid) => {
			let playButton = vid.querySelector('.play-button');
			let videoEl = vid.querySelector('video');
			let iframe = vid.querySelector('iframe');
			let cover = vid.querySelector('.responsive-video__cover');

			if (!playButton) return;

			if (iframe) {
				let iframeOriginalSrc = iframe.getAttribute('src');

				iframe.setAttribute('src', iframe.getAttribute('src') + '&showinfo=0&controls=0');
			}

			playButton.addEventListener('click', (ev) => {
				vid.classList.add('playing');
			});

			playButton.addEventListener('transitionend', (ev) => {
				playButton.parentNode.removeChild(playButton);

				if (cover) {
					cover.parentNode.removeChild(cover);
				}

				if (videoEl) {
					videoEl.setAttribute('controls', 'controls');
					videoEl.play();
				}

				if (iframe) {
					iframe.setAttribute('src', iframe.getAttribute('src') + '&autoplay=1');
				}
			});
		});
	}

	function body_scroll() {
		window.addEventListener(
			'scroll',
			throttle(() => {
				window.scrollY > 100 ? document.body.classList.add('scrolled') : document.body.classList.remove('scrolled');
			}, 150)
		);
	}

	function getUrlParams(search) {
		if (search.length <= 1) return {};
		const hashes = search.slice(search.indexOf('?') + 1).split('&');
		const params = {};
		hashes.map((hash) => {
			const [key, val] = hash.split('=');
			params[key] = decodeURIComponent(val);
		});
		return params;
	}

	function accordions() {
		let accordions = Array.from(document.querySelectorAll('[data-accordion]'));

		if (accordions.length === 0) return;

		accordions.forEach((accordion) => {
			let trigger = accordion.querySelector('[data-accordion-trigger]');

			trigger.addEventListener('click', (ev) => {
				accordion.classList.toggle('accordion-open');
			});
		});
	}

	return {
		init: init,
		getUrlParams: getUrlParams,
	};
})();
